import markScreenSelected from '../../gateways/browser/mark_screen_selected';
import mobileMenuKludge from '../../util/mobile_menu_kludge';

export default {
  name: 'WorkspacesController',
  fn: () => {
    mobileMenuKludge();
    markScreenSelected("workspaces");
  }
};